export function isErrorCode(error: unknown, code: number | string): boolean {
  if (typeof error !== "object" || error === null || !("code" in error)) {
    return false;
  }

  return (
    (typeof error.code === "number" || typeof error.code === "string") &&
    (typeof code === "number"
      ? Number(error.code) === code
      : error.code === code)
  );
}
